export default __webpack_public_path__ + "static/media/take_picture_of_work.6f184b88.svg";